module.exports = __webpack_public_path__ + "static/fipcbeepmain-67f893125678c2309aec84eb669c48e0.jpeg";